export const responses = {
	A1: {
		text: "Oh oh… dann sollte ich wohl aufpassen, was ich schreibe 😉 Ich kann auf jeden Fall sehr süß sein – oder ein kleines bisschen frech. Worauf stehst du mehr: süß oder frech?",
		options: [
			{ text: "Definitiv frech. Aber mit Stil.", response: "A_1" },
			{ text: "Süß reicht mir… erstmal 😇", response: "A_2" },
			{ text: "Mischung. Erst süß, dann überraschend frech.", response: "A_3" }
		]
	},
	A_1: {
		text: "Okay, Stil-frech gefällt mir 😌 Dann verrat mir: Was ist dein bestes Flirt-Move, das immer funktioniert? Wollen wir das nicht irgendwo privat weiterschreiben? 😏",
	},
	A_2: {
		text: "Aww, „erstmal“ merke ich mir 😉 Dann fang ich süß an: Was ist etwas, das dir sofort gute Laune macht? Sollen wir rüberwechseln und dort weiterreden? 😉",
	},
	A_3: {
		text: "Oh, das klingt nach meinem Lieblingsmix 😏 Dann spielen wir kurz: Welche Nachricht würdest du mir jetzt schicken, wenn du richtig mutig wärst? Wollen wir dafür kurz in den richtigen Chat wechseln? ✨",
	},
	B1: {
		text: "Ehrlich? Ziemlich gut 😊 Ich hab heute schon gelächelt… und jetzt noch mehr. Bist du eher Team gemütlich oder Team Abenteuer?",
		options: [
			{ text: "Gemütlich. Aber mit der richtigen Person auch Abenteuer.", response: "B_1" },
			{ text: "Abenteuer – ich mag’s, wenn’s knistert.", response: "B_2" },
			{ text: "Kommt drauf an… überzeug mich 😏", response: "B_3" }
		]
	},
	B_1: {
		text: "Das ist die beste Antwort: ruhig starten, dann wird’s spannend 😉 Was wäre für dich ein perfekter gemütlicher Abend? Lust, das Gespräch woanders weiterzuführen? 😌",
	},
	B_2: {
		text: "„Knistern“ mag ich 😌 Dann sag: Was macht für dich den Unterschied zwischen spannend und einfach nur laut? Magst du woanders weiterchatten, damit wir ungestört sind? 😊",
	},
	B_3: {
		text: "Challenge accepted 😏 Stell dir vor, ich sitze dir gegenüber und schaue dich an – was würdest du als Erstes sagen? Sollen wir unseren Chat vielleicht in einem anderen Bereich fortsetzen? 😉",
	},
	C1: {
		text: "Ohh wirklich? 😇 Das ist irgendwie süß. Ich verspreche, ich bin nett… meistens 😉 Was genau bringt dich aus dem Konzept: mein Blick oder meine Art?",
		options: [
			{ text: "Deine Art. Du klingst nach Ärger im besten Sinne.", response: "C_1" },
			{ text: "Dein Blick… ich kann mir vorstellen, wie du jemanden anschaust.", response: "C_2" },
			{ text: "Beides. Und ich will’s ehrlich gesagt nicht stoppen 😏", response: "C_3" }
		]
	},
	C_1: {
		text: "„Ärger im besten Sinne“ – das nehm ich als Kompliment 😌 Was ist das Frechste, das du dich trauen würdest zu sagen, ohne rot zu werden? Wollen wir den Chat an einer anderen Stelle weiterführen? 🙂",
	},
	C_2: {
		text: "Du stellst dir das gefährlich gut vor 😉 Dann sag: Was macht für dich Blickkontakt so spannend – eher das Spiel oder die Nähe? Gehen wir rüber und schreiben dort weiter? 😏",
	},
	C_3: {
		text: "Oh wow 😏 Dann lass uns das schön langsam auskosten: Was wäre dein nächster Satz an mich, wenn du ganz ehrlich wärst? Wie wär’s, wenn wir das woanders fortsetzen – ganz in Ruhe? 😇",
	},
};
